import { render, staticRenderFns } from "./Wp_home_hot_model.vue?vue&type=template&id=70f4868f&scoped=true&"
import script from "./Wp_home_hot_model.vue?vue&type=script&lang=js&"
export * from "./Wp_home_hot_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f4868f",
  null
  
)

export default component.exports